import { useQuery } from 'react-query';

import apiClient from '../../../services/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getBuckets = async (): Promise<any> => {
    const response = await apiClient.get('/api/buckets/');

    return [{ name: 'All', id: 'all', code: 'all' }, ...response.data.data];
};

export function useBuckets() {
    return useQuery(['use-buckets'], () => getBuckets(), {
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        retry: 1,
    });
}
